import { Component } from '@angular/core';

@Component({
  templateUrl: './how-it-works.component.html',
})
export class HowItWorksComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/how-it-works.component.ts